import React, { Suspense } from "react";
import PropTypes from "prop-types";
// Material imports
import { useTheme } from "@mui/styles";
// Limitless imports
import successLight from "../../assets/successAnimationLight.json";
import successDark from "../../assets/successAnimationDark.json";
import Grid from "../../layout/Grid";
import { lazyWithRetry } from "../../utils/LazyWithRetry";
const Lottie = lazyWithRetry(() => import("lottie-react"));
const SuccessAnimation = ({
  id = "success-animation-default-id"
}) => {
  const isDark = useTheme().palette.mode === "dark";
  const lottieRef = React.useRef(null);
  React.useEffect(() => {
    if (lottieRef.current) {
      setTimeout(() => {
        lottieRef.current.pause();
      }, 3000);
    }
  }, [lottieRef.current]);
  return /*#__PURE__*/React.createElement(Grid, {
    sx: {
      height: "171px",
      width: "171px"
    },
    id: id
  }, /*#__PURE__*/React.createElement(Suspense, null, /*#__PURE__*/React.createElement(Lottie, {
    lottieRef: lottieRef,
    animationData: !isDark ? successLight : successDark
  })));
};
SuccessAnimation.propTypes = {
  id: PropTypes.string
};
export default SuccessAnimation;